import { LOCAL_STORAGE_KEYS } from 'constant/localStorage';
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_INDEX,
  DEFAULT_PER_PAGE,
} from 'constant/table';
import { MRT_PaginationState } from 'material-react-table';

/**
 * @param page - The page number to sanitize
 * @param per_page - The per page number to sanitize
 * @param source - Where the page value comes from (affects default page index).
 *      = api - Backend/API context: page is 1-based (APIs typically use page 1 as first page).
 *      = mrt - MRT table context: page is 0-based (table pagination uses 0 as first page).
 * @default source - 'api'
 *
 * @example
 * const pagination = getSanitizedPagination({ page: 1, per_page: 10, source: 'api' });
 */
export const getSanitizedPagination = ({
  page,
  per_page,
  source = 'api',
}: {
  page: number;
  per_page: number;
  source?: 'api' | 'mrt';
}) => ({
  page: page || (source === 'api' ? DEFAULT_PAGE : 0),
  per_page:
    Number(per_page ?? 0) ||
    Number(localStorage.getItem(LOCAL_STORAGE_KEYS.PER_PAGE)) ||
    DEFAULT_PER_PAGE,
});

/**
 * @returns The default pagination state for MRT table
 */
export const getDefaultMrtPagination = () =>
  ({
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize:
      Number(localStorage.getItem(LOCAL_STORAGE_KEYS.PER_PAGE)) ||
      DEFAULT_PER_PAGE,
  }) satisfies MRT_PaginationState;
